import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import classNames from 'classnames';
import useLegendEventHandler from './useLegendEventHandler';

const useStyles = buildUseStyles('ChartLegendItem', ((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    columnGap: theme.spacing(1),
  },
  legendLine: {
    width: theme.spacing(2),
    height: 1,
    borderRadius: theme.spacing(2),
    borderTop: ({ color }) => `2px solid ${color}`,
  },
  legendCircle: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    borderRadius: '50%',
    border: ({ color }) => `2px solid ${color}`,
  },
})));

export const ChartLegendIcon = ({ color, type = 'line' }) => {
  const classes = useStyles({ color });

  let className;
  switch (type) {
    case 'line':
      className = classes.legendLine;
      break;
    case 'circle':
      className = classes.legendCircle;
      break;
    default:
      className = classes.legendLine;
  }

  return <>
    <Box className={className} />
  </>;
};

const ChartLegendItem = ({
  className, legendIcon, name,
}) => {
  const {
    handleLegendClick,
  } = useLegendEventHandler();

  const classes = useStyles();
  return (
    <Box
      className={classNames(classes.root, className)}
      onClick={() => handleLegendClick(name)}
    >
      {legendIcon}
      <Text
        text={name}
        align={'left'}
        color={'primaryGray'}
        weight={'bold'}
        variant={'h6'}
      />
    </Box>
  );
};

ChartLegendItem.defaultProps = {
  className: '',
};

ChartLegendItem.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  legendIcon: PropTypes.node.isRequired,
};

export default ChartLegendItem;
